// 2024(c) ESIEE Paris
// Author: CANDIA Nicolas <nicolas.candia@esiee.fr>

import $ from "~jquery/dist/jquery.slim";
import bootstrap from "~bootstrap/dist/js/bootstrap.bundle";
import 'material-icons/iconfont/material-icons.css';

import * as navigation from "./navigation";
import * as form from "./form";
import * as message from "./message";
import * as modal from "./modal";

import { TableTreeview } from './treeview';

window.TableTreeview = TableTreeview;

export function init() {

    // Navigation
    navigation.init();

    // Form
    form.init();

    // Message
    message.init();

    // Modal
    modal.init();
    
}